import { Warning, Paragraph } from '@hungryroot/ui-kit';
import { useFoodProfileNeversUrl } from '../../hooks/useFoodProfileNeversUrl';
import { tagNameUsesPluralAgreement } from '../../utils/tagNameUsesPluralAgreement';
import styles from './FoodProfileNeverOverrideAlert.module.css';

type FoodProfileNeverOverrideAlertProps = {
  tagName?: string | null;
};

export function FoodProfileNeverOverrideAlert(
  props: FoodProfileNeverOverrideAlertProps
) {
  const { tagName } = props;
  const foodProfileNeversUrl = useFoodProfileNeversUrl();
  const usesPluralAgreement = tagName
    ? tagNameUsesPluralAgreement(tagName)
    : false;

  return (
    <div
      className={styles.container}
      data-testid="food-profile-never-override-alert"
    >
      <div className={styles['warning-icon-container']}>
        <Warning />
      </div>
      <Paragraph variant="caption">
        {tagName ? (
          <>
            {tagName} {usesPluralAgreement ? 'are' : 'is'} on your never list -
            change {usesPluralAgreement ? 'them' : 'it'} in your{' '}
            <a className={styles.link} href={foodProfileNeversUrl}>
              Food Profile
            </a>
          </>
        ) : (
          <>
            This setting is being overridden by your{' '}
            <a className={styles.link} href={foodProfileNeversUrl}>
              Food Profile
            </a>
            .
          </>
        )}
      </Paragraph>
    </div>
  );
}
